import React from 'react';
import { Box, Stack } from '@mui/material';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';
import { LenderRetailActivityLenderRowViewModel } from '../../../api/types';
import { LenderAppsSorting } from '../../../types';
import { LenderAppsTable } from './LenderAppsTable';
import { FinancedDistribution } from './FinancedDistribution';
import { RequestedFinancing } from './RequestedFinancing';

interface Props {
  rows: LenderRetailActivityLenderRowViewModel[];
  loading?: boolean;
  sorting: LenderAppsSorting;
  onSortingChange: (nextValue: LenderAppsSorting) => void;
}

export const LenderApps = ({ rows, loading, sorting, onSortingChange }: Props) => (
  <CardContainer title="Lender Apps">
    <Stack gap={3} sx={{ mt: 1 }}>
      <LenderAppsTable rows={rows} loading={loading} sorting={sorting} onSortingChange={onSortingChange} />

      <Box sx={{ display: 'grid', gap: 3, gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' } }}>
        <FinancedDistribution rows={rows} loading={loading} />
        <RequestedFinancing rows={rows} loading={loading} />
      </Box>
    </Stack>
  </CardContainer>
);
